import { lazy } from 'react';

const Lobby = lazy(() => import('features/lobby/containers/Lobby'));
const Profile = lazy(() => import('features/Profile/container/Profile'));
const Verification = lazy(() => import('features/Profile/component/Verification'));
const CreateContest = lazy(() => import('features/createContest/container/CreateContest'));
const ContestDetails = lazy(() => import('features/contestDetails/container/ContestDetails'));
const InviteFriendCompetition = lazy(() => import('features/createContest/components/InviteFriendCompetition'));
const Wallet = lazy(() => import('features/wallet/container/Wallet'));
const TopUpAccount = lazy(() => import('features/wallet/component/TopUpAccount'));
const EmailVerification = lazy(() => import('features/auth/component/EmailVerification'));
const SignUp = lazy(() => import('features/auth/component/SignUp'));
const Login = lazy(() => import('features/auth/container/Login'));
const ResetPassword = lazy(() => import('features/password/components/ResetPassword'));
const PasswordRecovery = lazy(() => import('features/password/container/PasswordRecovery'));
const PageNotFound = lazy(() => import('shared/components/errors/pageNotFound'));
const RequestFailError = lazy(() => import('shared/components/errors/requestFailError'));

export {
	Profile,
	Verification,
	Lobby,
	CreateContest,
	ContestDetails,
	InviteFriendCompetition,
	Wallet,
	TopUpAccount,
	EmailVerification,
	SignUp,
	Login,
	ResetPassword,
	PasswordRecovery,
	PageNotFound,
	RequestFailError
};
